import {put,takeLatest,call} from 'redux-saga/effects';
import * as ordersService from "../../../services/orderService";
import {
    GET_ALL_ORDERS,
    GET_ALL_ORDERS_SUCCESS,
    GET_ALL_ORDERS_ERROR
}
    from "../../actions/order";
function* getAllOrdersSaga(action) {
    try {
        const data=yield call(ordersService.GetAllOrders,action.payload)
        yield put({
            type: GET_ALL_ORDERS_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_ALL_ORDERS_ERROR,error: error.data
        });
    }
}

export function* getAllOrdersSagaWatcher() {
    yield takeLatest(GET_ALL_ORDERS,getAllOrdersSaga);
}